var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoExplosion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9168 10.7407C18.5277 12.3516 18.5277 14.9634 16.9168 16.5743C15.3059 18.1852 12.6942 18.1852 11.0833 16.5743C9.47237 14.9634 9.47237 12.3516 11.0833 10.7407C12.6942 9.12979 15.3059 9.12979 16.9168 10.7407Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1003 5.8092C12.8492 4.78864 15.0443 4.79171 16.8326 5.8092",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8483 10.825C22.8689 12.5739 22.8658 14.769 21.8483 16.5572",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8997 21.5058C15.1508 22.5264 12.9557 22.5233 11.1674 21.5058",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1517 16.4901C5.13114 14.7411 5.13421 12.546 6.1517 10.7578",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72439 7.38192C8.15486 6.95146 8.85277 6.95146 9.28324 7.38192C9.7137 7.81238 9.7137 8.5103 9.28324 8.94076C8.85277 9.37122 8.15486 9.37122 7.72439 8.94076C7.29393 8.5103 7.29393 7.81238 7.72439 7.38192Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7168 18.3741C19.1472 17.9436 19.8451 17.9436 20.2756 18.3741C20.7061 18.8046 20.7061 19.5025 20.2756 19.9329C19.8451 20.3634 19.1472 20.3634 18.7168 19.9329C18.2863 19.5025 18.2863 18.8046 18.7168 18.3741Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2756 7.38183C20.706 7.8123 20.706 8.51021 20.2756 8.94068C19.8451 9.37114 19.1472 9.37114 18.7167 8.94068C18.2862 8.51021 18.2862 7.8123 18.7167 7.38183C19.1472 6.95137 19.8451 6.95137 20.2756 7.38183Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28327 18.3741C9.71374 18.8046 9.71374 19.5025 9.28327 19.933C8.85281 20.3634 8.15489 20.3634 7.72443 19.933C7.29397 19.5025 7.29397 18.8046 7.72443 18.3741C8.15489 17.9437 8.85281 17.9437 9.28327 18.3741Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExplosion);
export default __webpack_public_path__ + "static/media/ico-explosion.ad0b58d4.svg";
export { ForwardRef as ReactComponent };